import { AdminStudies } from '../types';
import { dateFormatFn } from '../utils/utils';
import { WebEntity } from './types';

const AdminStudiesEntity: WebEntity<AdminStudies> = {
  name: 'studiesInProgress',
  endpoint: 'estudios/admin',
  referenceColumn: 'nombreSimulacion',
  tableColumns: [
    {
      header: 'ID',
      accessorKey: '_id',
      omitExport: true,
      columnType: 'text',
      enableHiding: false,
      visibleInShowHideMenu: false
    },
    {
      header: 'Tipo de Estudio',
      accessorKey: 'tipoSimulacion',
      columnType: 'text',
      size: 180
    },
    {
      header: 'Fecha de Ingreso',
      accessorKey: 'fechaCreacion',
      columnType: 'dateUTC',
      size: 180,
      Cell: ({ row }) => dateFormatFn(row?.original?.fechaCreacion, 'DD/MM/YYYY', true)
    },
    {
      header: 'Nombre del Estudio',
      accessorKey: 'nombreSimulacion',
      columnType: 'text',
      size: 200
    },
    {
      header: 'Empresa ID',
      accessorKey: 'empresaId',
      columnType: 'text',
      size: 150
    },
    {
      header: 'Alimentador ID',
      accessorKey: 'alimentadorId',
      columnType: 'text',
      size: 170
    }
  ]
};

export default AdminStudiesEntity;
